import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  UPDATE_IMPORT_DOCUMENT,
  UPDATE_IMPORT_DOCUMENT_SUCCESS,
  UPDATE_IMPORT_DOCUMENT_FAILURE,
  UpdateImportDocumentActionType
} from 'src/redux/importDocumentReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* UpdateImportDocumentFlow(action: UpdateImportDocumentActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/import_documents/${action.payload.id}`
    const response: { pdf_url: string } = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: PUT,
      params: {
        import_document: action.payload.values
      }
    })
    yield put(UPDATE_IMPORT_DOCUMENT_SUCCESS({ pdf_url: response.pdf_url }))
  } catch (error) {
    yield put(UPDATE_IMPORT_DOCUMENT_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* UpdateImportDocumentSaga(): Generator<any, void, any> {
  yield takeLatest(UPDATE_IMPORT_DOCUMENT, UpdateImportDocumentFlow)
}
